import { useState } from "react";

const defaultUserFallback = {
    name: "Hunter Souza",
    expiration: new Date(2000, 1, 1)
}

export default function useUser() {
    const getUser = () => {
        const userString = localStorage.getItem('PROFILE_DATA_SISCOPE') ?? "{}";
        const user = JSON.parse(userString) ?? defaultUserFallback;

        return user;
    }

    const [user, setUser] = useState(getUser())

    const saveUser = (user) => {
        localStorage.setItem('PROFILE_DATA_SISCOPE',JSON.stringify(user))
        setUser(user)
    }

    return {
        user,
        setUser: saveUser,
        authed: (new Date(user.expiration) > new Date())
    }
}
